// extracted by mini-css-extract-plugin
module.exports =  {"saved-search-labels":"_32bbee5fda--saved-search-labels--k9skJ"};